import { AxiosResponse } from 'axios';

export const contentDispositionExtraction = (
  response: AxiosResponse<BlobPart>
) => {
  const contentDisposition = response.headers?.['content-disposition'];
  let fileName;
  if (contentDisposition && contentDisposition.includes('attachment')) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      fileName = match[1];
    }
  }
  return fileName;
};
